'use strict';

import React from 'react';
import WemfTracking from '../wemftracking/WemfTracking';
import GoogleAnalytics from '../googleAnalytics/GoogleAnalytics';
import GtmTracking from '../gtmTracking/GtmTracking';

const Statistics = (props) => {
  return (
    <div>
      <WemfTracking projectId={props.projectId}/>
      <GoogleAnalytics/>
      <GtmTracking/>
    </div>
  )
};

Statistics.propTypes = {
  projectId: React.PropTypes.string,
};

Statistics.defaultProps = {
  projectId: 'default-project'
};

export default Statistics;



/** WEBPACK FOOTER **
 ** ./src/components/statistics/Statistics.js
 **/